import { Box } from '@mui/material';

import { Sector } from '@/domain/impact/impact.entity';
import { translate } from '@/ui/i18n';
import { AccommodationForm } from '@/ui/pages/app/components/quiz-panel/co2/components/forms/AccommodationForm';
import { CargoForm } from '@/ui/pages/app/components/quiz-panel/co2/components/forms/CargoForm.tsx';
import { CateringBeverageForm } from '@/ui/pages/app/components/quiz-panel/co2/components/forms/CateringBeverageForm';
import { CateringMealForm } from '@/ui/pages/app/components/quiz-panel/co2/components/forms/CateringMealForm';
import { EquipmentForm } from '@/ui/pages/app/components/quiz-panel/co2/components/forms/EquipmentForm';
import { MobilityForm } from '@/ui/pages/app/components/quiz-panel/co2/components/forms/MobilityForm';
import { QuizFormSectionTitle } from '@/ui/pages/app/components/quiz-panel/co2/components/QuizFormSectionTitle';
import { ImpactQuestionContext } from '@/ui/pages/app/components/quiz-panel/ImpactQuestionContext';

import { useCo2DayQuizSubmitAnswer } from './useCo2DayQuizSubmitAnswer';

export function Co2DayQuiz({
  sector,
  dateId,
}: {
  sector: Sector;
  dateId: number;
}) {
  const { onSubmit, onEdit, onDelete } = useCo2DayQuizSubmitAnswer(dateId);

  return (
    <ImpactQuestionContext.Provider
      value={{ panelOpen: true, hideCompleted: false }}
    >
      <Box>
        <QuizFormSectionTitle
          title={translate('ProjectsVenue.DayCo2Quiz.artistic-team')}
        />
        <MobilityForm
          sector={sector}
          onDelete={onDelete}
          onSubmit={onSubmit}
          onEdit={onEdit}
        />
        <CateringMealForm
          sector={sector}
          onDelete={onDelete}
          onSubmit={onSubmit}
          onEdit={onEdit}
        />
        <CateringBeverageForm
          sector={sector}
          onDelete={onDelete}
          onSubmit={onSubmit}
          onEdit={onEdit}
        />
        <AccommodationForm
          sector={sector}
          onDelete={onDelete}
          onSubmit={onSubmit}
          onEdit={onEdit}
        />
        <CargoForm
          sector={sector}
          onDelete={onDelete}
          onSubmit={onSubmit}
          onEdit={onEdit}
        />
        <EquipmentForm
          sector={sector}
          onDelete={onDelete}
          onSubmit={onSubmit}
          onEdit={onEdit}
        />
      </Box>
    </ImpactQuestionContext.Provider>
  );
}
